module.exports = __webpack_public_path__ + "static/media/ideal_env-icon.7dd5cab3.svg";